export default /*@ngInject*/ function (applicationInsightsServiceProvider) {
    var options = { applicationName: '' };
    // Configuration options are described below
    applicationInsightsServiceProvider.configure(applicationInsightsKey, options);
}